import { post, postData } from './http'
import global from '@/api/global'
var name = global.dataCenterName
var zhbname = global.dataCenterNamezhb
var wmsCenter = global.wmsCenter
var signature = global.signature
// var name = '/crm'
// // 租户管理-查询
// export const TenantSeatch = p => post(name + '/tenant/getTenantList', p)

// 获取地图流向数据
export const initDatas = p => post(name + '/map/coordinate', p)
// 获取地图存储数据
export const initKucuns = p => post(name + '/map/data', p)

// #storage
// 获取仓储出入库记录
export const churkuData = p => post(name + '/storage/accessRecord', p)
// 获取仓库客户统计
export const kehuData = p => post(name + '/storage/customerTotal', p)
// 获取仓库实时数据
export const cangkuData = p => post(name + '/storage/realTotal', p)
// 获取出入库波动
export const bodongData = p => post(name + '/storage/accessTotal', p)

// 钢厂汽运数据
export const gangchangData = p => post(name + '/steel/total', p)
// 日拉运计划统计
export const planData = p => post(name + '/steel/planTotal', p)

// 各车队日拉运情况
export const fleetData = p => post(name + '/steel/fleetTotal', p)
// 各系统车辆统计
export const carData = p => post(name + '/steel/carTotal', p)
// 日配货量趋势
export const distributiogData = p =>
  post(name + '/steel/distributionTotal', p)
// 配货实时记录
export const distributionRecord = p =>
  post(name + '/steel/distributionRecord', p)

// 船运-基本数据
export const shipInfosData = p => post(name + '/ship/infos', p)
// 船舶统计数据
export const shipTotalData = p => post(name + '/ship/total', p)
// 合作港口货物信息
export const shippartRecordData = p =>
  post(name + '/ship/partRecord', p)
// 船运量月度趋势
export const shipmonthTotalData = p => post(name + '/ship/monthTotal', p)

// 中厚板大屏
export const rawStockData = p => post(name + '/zhbLargeScreen/rawStockData', p)// 原料
export const zhbVehicleMonitor = p => post(name + '/zhbLargeScreen/zhbVehicleMonitor', p) // 监控
export const finishedProduct = p => post(name + '/zhbLargeScreen/finishedProduct', p) // 成品-1-数据
export const fleetTransportData = p => post(name + '/zhbLargeScreen/fleetTransportData', p) // 成品-1-数据
export const taskMonitoring = p => post(name + '/zhbLargeScreen/taskMonitoring', p) // 成品-1-数据

export const getLatheoperator = p => post(name + '/tWms/getLatheoperator', p) // 仓储-作业统计
export const getStatistics = p => post(name + '/tWms/getStatistics', p) // 仓储-作业统计

// 货主端大屏
export const socOrderrecordList = p => post(name + '/socOrderWms/socOrderrecordList', p)// 物流业务-订单数据
export const socWayrecordList = p => post(name + '/socOrderWms/socWayrecordList', p)// 物流业务-运单数据
export const socOrderTotal = p => post(name + '/socOrderWms/socOrderTotal', p)// 物流业务-物流数据
export const orderWave = p => post(name + '/socOrderWms/orderWave', p)// 物流业务-发货数据统计
export const getSocBillWaveList = p => post(name + '/socOrderWms/getSocBillWaveList', p)// 仓储业务-提货转货统计
export const getSocWarehouseList = p => post(name + '/socOrderWms/getSocWarehouseList', p)// 仓储业务-仓库货物统计
export const getSocBillStatician = p => post(name + '/socOrderWms/getSocBillStatician', p)// 业务宏图-提货数据
export const getTotalWeightList = p => post(name + '/socOrderWms/getTotalWeightList', p)// 业务宏图-提货数据
// 海运大屏
// export const yearWaterTransList = p => post(name + '/freighter/yearWaterTransList', p)// 业务趋势折线
// export const recordList = p => post(name + '/freighter/recordList', p)// 水运记录
// export const listTotal = p => post(name + '/freighter/listTotal', p)// 历史量统计
// export const waterStatusList = p => post(name + '/freighter/waterStatusList', p)// 水运单船期状态
export const listTrans = p => post(name + '/freighter/listTrans', p)// 疏港统计
export const addressList = p => post(name + '/freighter/addressList', p)// 地图上得码头仓库
// export const codeDataList = p => post(name + '/freighter/codeDataList', p)// 地图上得折线
export const getAllTenants = p => post(name + '/freighter/getAllTenants', p)// 获取平台的租户
// 改版后的接口（梁）
export const listTotal = p => post(name + '/dShipDate/sumHistoryWeight', p)// 历史量统计
export const yearWaterTransList = p => post(name + '/dShipDate/weightByMonth', p)// 业务趋势折线
export const waterStatusList = p => post(name + '/dShipDate/statusCount', p)// 水运单船期状态
export const recordList = p => post(name + '/dShipDate/shipDateList', p)// 船期记录
export const codeDataList = p => post(name + '/dShipDate/shipAddressAndCoordinate', p)// 地图上得折线

// 货物全流程
export const goodList = p => post(name + '/soc/good/history/list', p)// 列表
export const gmonitoringList = p => post(name + '/soc/good/history/monitoring/listRecord', p)
// 中午供应链平台大屏
export const dailyAndHistoryTotal = p => post(name + '/zhdpTotal/dailyAndHistoryTotal', p)// 当天各数据
export const packTotal = p => post(name + '/zhdpTotal/packTotal', p)// 包装
export const carTotal = p => post(name + '/zhdpTotal/carTotal', p)// 汽运
export const shipTotal = p => post(name + '/zhdpTotal/shipTotal', p)// 海运
export const warehouseTotal = p => post(name + '/zhdpTotal/warehouseTotal', p)// 仓储
// 加工业务
export const typeWeightList = p => post(name + '/processStatistical/typeWeightList', p)// 加工类型统计（柱，涛）
export const totalList = p => post(name + '/processStatistical/totalList', p)// 加工类型分布（饼，涛）
export const trendList = p => post(name + '/processStatistical/trendList', p)// 加工量趋势（折，涛）
export const PSrecordList = p => post(name + '/processStatistical/recordList', p)// 实时验收数据（涛）
// --------------包装大屏------------
export const dPackHistoryList = p => post(name + '/dPackHistory/list', p)// 包装大屏-历史趋势
export const dPackRealtimeData = p => post(name + '/dPackRealtimeData/list ', p)// 包装大屏-实时数据
// ---------------报表统计--------------------
export const socActiveList = p => post(name + '/socActive/list', p)// 货主数据列表
export const activeStatistical = p => post(name + '/socActive/activeStatistical', p)// 数据统计
export const getMonthStatistics = p => post(name + '/socActive/getMonthStatistics', p)// 货主新增趋势
export const listStatistics = p => post(name + '/socActive/listStatistics', p)// 货主活跃度对比
// export const productNameList = p => post(name + '/dSocWayTransport/productNameList', p)// 平台运价统计-货物分类
// export const getTrafficCountNoGroup = p => post(name + '/dSocWayTransport/getTrafficCountNoGroup', p)// 平台运价统计-数据统计
// export const productWeightList = p => post(name + '/dSocWayTransport/productWeightList', p)// 平台运价统计-重量分类
// export const getTrafficCount = p => post(name + '/dSocWayTransport/getTrafficCount', p)// 平台运价统计-12月波动折线图
// export const getPriceCount = p => post(name + '/dSocWayTransport/getPriceCount', p)// 平台运价统计-运价统计
// 找车-车队报表（常艳）
export const sDemandOrderList = p => post(name + '/sDemandOrder/list', p)
// 散货大屏====
export const findDisplayStockList = p => post(wmsCenter + '/displayStock/findDisplayStockList', p)// 库存录入列表
export const findDisplayStockStatistics = p => post(wmsCenter + '/displayStock/findDisplayStockStatistics', p)// 查询库存量列表统计
export const deleteDisplayStock = p => post(wmsCenter + '/displayStock/deleteDisplayStock', p)// 删除大屏客户库存
export const addDisplayStockList = p => post(wmsCenter + '/displayStock/addDisplayStockList', p)// 添加大屏客户库存
export const findDisplayOperationList = p => post(wmsCenter + '/displayOperation/findDisplayOperationList', p)// 查询入出库作业列表
export const findDisplayOperationStatistics = p => post(wmsCenter + '/displayOperation/findDisplayOperationStatistics', p)// 查询入出库作业列表统计
export const deleteDisplayOperation = p => post(wmsCenter + '/displayOperation/deleteDisplayOperation', p)// 删除大屏入出库作业数据
export const addDisplayOperationList = p => post(wmsCenter + '/displayOperation/addDisplayOperationList', p)// 添加大屏入出库作业
export const updateDisplayOperation = p => post(wmsCenter + '/displayOperation/updateDisplayOperation', p)// 修改大屏入出库作业
export const findCustomerDropDownBox = p => post(wmsCenter + '/displayStock/findCustomerDropDownBox', p)// 客户下拉
export const findInventoryQuantity = p => post(wmsCenter + '/warehouseDataDisplay/findInventoryQuantity', p)// 大屏查询库存量
export const findOperationQuantity = p => post(wmsCenter + '/warehouseDataDisplay/findOperationQuantity', p)// 大屏日出入库量
export const findInventoryQuantityFluctuation = p => post(wmsCenter + '/warehouseDataDisplay/findInventoryQuantityFluctuation', p)// 大屏查询日库存量波动
export const findOperationQuantityList = p => post(wmsCenter + '/warehouseDataDisplay/findOperationQuantityList', p)// 大屏查询入出库作业列表
export const findInOutQuantityFluctuation = p => post(wmsCenter + '/warehouseDataDisplay/findInOutQuantityFluctuation', p)// 大屏查询日出入库存量波动
export const findTenantNameList = p => post(wmsCenter + '/warehouseDataDisplay/findTenantNameList', p)// 大屏查询租户列表
export const findDisplayOperationBox = p => post(wmsCenter + '/displayOperation/findDisplayOperationBox', p)// 大屏查询货物类型列表
export const findShWhList = p => post(wmsCenter + '/warehouseDataDisplay/findShWhList', p)// 散货仓储列表
export const findInventoryQuantityByWh = p => post(wmsCenter + '/warehouseDataDisplay/findInventoryQuantityByWh', p)// 查询库存量（仓库维度）
export const findInventoryQuantityFluctuationByWh = p => post(wmsCenter + '/warehouseDataDisplay/findInventoryQuantityFluctuationByWh', p)// 查询库存量波动(仓库维度)
export const findOperationQuantityByWh = p => post(wmsCenter + '/warehouseDataDisplay/findOperationQuantityByWh', p)// 查询日出入库量（仓库维度）
export const findInOutQuantityFluctuationByWh = p => post(wmsCenter + '/warehouseDataDisplay/findInOutQuantityFluctuationByWh', p)// 查询出入库存量波动（仓库维度）
export const videoAlertList = p => post(signature + '/videoAlert/list', p)// 安全警告列表
export const videoAlertUpdateRead = p => post(signature + '/videoAlert/updateRead', p)// 设置成已读
export const videoAlertUnreadNu = p => post(signature + '/videoAlert/videoAlertUnreadNu', p)// 智能预警未读数
export const findMolecularCompanyRank = p => post(name + '/largeScreenDisplay/findMolecularCompanyRank', p)// 物流运输大屏-分子公司业务排行
export const findCargoTypeDistribution = p => post(name + '/largeScreenDisplay/findCargoTypeDistribution', p)// 物流运输大屏-货型分布
export const findDirectionTop = p => post(name + '/largeScreenDisplay/findDirectionTop', p)// 物流运输大屏-优质流向Top5
export const findCustomerTop = p => post(name + '/largeScreenDisplay/findCustomerTop', p)// 物流运输大屏-客户运量排行Top10
export const findCoordinate = p => post(name + '/largeScreenDisplay/findCoordinate', p)// 物流运输大屏-中间地图坐标
export const findAnnualTrend = p => post(name + '/largeScreenDisplay/findAnnualTrend', p)// 物流运输大屏-年度走势
// 调度看板大屏
export const findTodayOperation = p => post(name + '/tmsTodayOperationStat/findTodayOperation', p)// 当日作业
export const findVhcEnergyStat = p => post(name + '/tmsTodayOperationStat/findVehicleEnergyStat', p)// 自家车辆能源类型统计
export const findVhcDistribution = p => post(name + '/tmsTodayOperationStat/findVehicleCityDistribution', p)// 车辆分布饼图
export const findCertificate = p => post(name + '/tmsTodayOperationStat/findCertificateExpireStat', p)// 证件异常数量统计
export const findSigningTrendStat = p => post(name + '/tmsTodayOperationStat/findSigningTrendStat', p)// 实时拉运情况
export const findTopFlowStat = p => post(name + '/tmsTodayOperationStat/findTopFlowStat', p)// 流向情况
export const findVehicleEnergyRank = p => post(name + '/tmsTodayOperationStat/findVehicleEnergyRank', p)// 能耗排行
export const findOwnFleetStat = p => post(name + '/tmsTodayOperationStat/findOwnFleetStat', p)// 自由运力统计
export const findVehicleMapLocation = p => post(name + '/tmsTodayOperationStat/findVehicleMapLocation', p)// 地图数据
export const findVehicleInspectionStat = p => post(name + '/tmsTodayOperationStat/findVehicleInspectionStat', p)// 车辆年检
